import { render, staticRenderFns } from "./RedirectInvoice.vue?vue&type=template&id=23d20cc0&scoped=true&"
import script from "./RedirectInvoice.vue?vue&type=script&lang=js&"
export * from "./RedirectInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d20cc0",
  null
  
)

export default component.exports